import React from "react";
import { Link } from "react-router-dom";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// @material-ui/icons

// core components
// import Carousel from "react-slick";
// import carouselStyle from "assets/jss/material-kit-react/views/componentsSections/carouselStyle.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";

import teamStyle from "assets/jss/material-kit-react/views/landingPageSections/teamStyle.jsx";


import training from "assets/img/training.jpeg";
import consulting from "assets/img/consulting.jpeg";
import certificate from "assets/img/certificate.png";
import auditing from "assets/img/auditing.png";

class TeamSection extends React.Component {
  render() {
    const { classes } = this.props;
    const imageClasses = classNames(
      classes.imgRaised,
      // classes.imgRoundedCircle,
      classes.imgFluid
    );
    // const settings = {
    //   dots: false,
    //   // infinite: true,
    //   speed: 1000,
    //   slidesToShow: 3,
    //   slidesToScroll: 1,
    //   autoplay: true,
    //   autoplaySpeed: 1000,
    //   pauseOnHover: false
    // };
    return (
      <div className={classes.section}>
        <h2 className={classes.title} style={{ color: "#4BB64B" }}>Our Services</h2>
        <div>
          <GridContainer>
            <GridItem xs={12} sm={12} md={3}>
              <Card plain>
                <GridItem xs={12} sm={12} className={classes.itemGrid}>
                  <Link to="service/certification" className={classes.link}>
                    <img src={certificate} alt="..." className={imageClasses} />
                  </Link>
                </GridItem>
                <h4 className={classes.cardTitle}>
                  <Link to="service/certification" className={classes.link}>
                    Certification
                  </Link>
                </h4>
                <CardBody>
                  <Link to="service/certification" className={classes.link}>
                    <p className={classes.description}>
                      To meet industrial standard brings you benefits immediately in short term as well as in the long run. There are a numbers of certification standards that we can bring to you in order to achieve your goals
                  </p>
                  </Link>
                </CardBody>
              </Card>
            </GridItem>
            <GridItem xs={12} sm={12} md={3}>
              <Card plain>
                <GridItem xs={12} sm={12} className={classes.itemGrid}>
                  <Link to="service/training" className={classes.link}>
                    <img src={training} alt="..." className={imageClasses} />
                  </Link>
                </GridItem>
                <h4 className={classes.cardTitle}>
                  <Link to="service/training" className={classes.link}>
                    Training
                  </Link>
                </h4>
                <CardBody>
                  <Link to="service/training" className={classes.link}>
                    <p className={classes.description}>
                      Our training covers business management pactices and mainly related to quality management, project management and risk management
                  </p>
                  </Link>
                </CardBody>
              </Card>
            </GridItem>
            <GridItem xs={12} sm={12} md={3}>
              <Card plain>
                <GridItem xs={12} sm={12} className={classes.itemGrid}>
                  <Link to="service/auditing" className={classes.link}>
                    <img src={auditing} alt="..." className={imageClasses} />
                  </Link>
                </GridItem>
                <h4 className={classes.cardTitle}>
                  <Link to="service/auditing" className={classes.link}>
                    Auditing
                  </Link>
                </h4>
                <CardBody>
                  <Link to="service/auditing" className={classes.link}>
                    <p className={classes.description}>
                      Auditing services, will help the company assure its products, services, equipment and facilities to fulfill requirements, standards, and national or international rules.
                    </p>
                  </Link>
                </CardBody>
              </Card>
            </GridItem>
            <GridItem xs={12} sm={12} md={3}>
              <Card plain>
                <GridItem xs={12} sm={12} className={classes.itemGrid}>
                  <Link to="service/consulting" className={classes.link}>
                    <img src={consulting} alt="..." className={imageClasses} />
                  </Link>
                </GridItem>
                <h4 className={classes.cardTitle}>
                  <Link to="service/consulting" className={classes.link}>
                    Consultancy
                  </Link>
                </h4>
                <CardBody>
                  <Link to="service/consulting" className={classes.link}>
                    <p className={classes.description}>
                      Consultancy service brings you hassle-free solutions of any ad-hoc yet strategic tasks that is critical to your business growth. These kind of tasks usually requires external expertise to asses, plan, execute and monitor so that you can focus on you core busines.
                  </p>
                  </Link>
                </CardBody>
              </Card>
            </GridItem>
            
          </GridContainer>
        </div>
      </div>
    );
  }
}

export default withStyles(teamStyle)(TeamSection);



// WEBPACK FOOTER //
// ./src/views/HomePage/Sections/TeamSection.1.jsx